import ResponsiveUtilities from './responsive-utilities';
import SiteUtilities from './site-utilities';
import LocationUtilities from './location-utilities';
import FormUtilities from './form-utilities';
import CoordinatesUtilities from './coordinates-utilities';
import GA4Utilities from './ga4-utilities';
import A11y from './a11y-utilities';

function init () {
  // SiteUtilities
  SiteUtilities.setTacticID();
  SiteUtilities.setGclId();
  SiteUtilities.setUtmMedium();
  SiteUtilities.addNoOpener();
  ResponsiveUtilities.init();
  LocationUtilities.init();
  FormUtilities.init();
  CoordinatesUtilities.init();
  GA4Utilities.init();
}

// Doing two exports, so that import destructuring is possible
export {
  init,
  ResponsiveUtilities,
  SiteUtilities,
  LocationUtilities,
  FormUtilities,
  GA4Utilities,
  A11y
};

export default {
  init,
  ResponsiveUtilities,
  SiteUtilities,
  LocationUtilities,
  FormUtilities,
  GA4Utilities,
  A11y
};
